import PosthogService from '~/services/posthog/PosthogService';
import type { TInviteShiftStatus } from './types';

export interface IShiftSelectedPayload {
  shiftId: string;
  shiftStatus: TInviteShiftStatus;
}

/**
 * Fires when the user selects a shift in the Invite popup
 * Event: dental_portal:invite:shift_selected
 */
export function fireShiftSelected(payload: IShiftSelectedPayload): void {
  PosthogService.getInstance().track('dental_portal:invite:shift_selected', {
    shift_id: payload.shiftId,
    shift_status: payload.shiftStatus,
  });
}
